<template>
  <div>
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <!-- User Info: Input Fields -->
      <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <b-row>
          <!-- Field: Alias -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="validationContext"
              :name="$t('AppCustomer.columns.nickname')"
              rules="required|max:10"
            >
              <b-form-group
                :label="$t('AppCustomer.columns.nickname')"
                label-for="alias"
              >
                <b-form-input
                  id="alias"
                  v-model="clienteData.alias"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Field: Nombre -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="validationContext"
              :name="$t('AppCustomer.columns.name')"
              rules="required|max:150"
            >
              <b-form-group
                :label="$t('AppCustomer.columns.name')"
                label-for="nombre"
              >
                <b-form-input
                  id="nombre"
                  v-model="clienteData.nombre"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Field: Rfc -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="validationContext"
              :name="$t('AppCustomer.columns.rfc')"
              rules="required|max:13|min:12"
            >
              <b-form-group
                :label="$t('AppCustomer.columns.rfc')"
                label-for="rfc"
              >
                <b-form-input
                  id="rfc"
                  v-model="clienteData.rfc"
                  :state="getValidationState(validationContext)"
                  onkeyup="this.value = this.value.toUpperCase();"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Field: Domicilio -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="validationContext"
              :name="$t('AppCustomer.columns.address')"
              rules="required|max:250"
            >
              <b-form-group
                :label="$t('AppCustomer.columns.address')"
                label-for="domicilio"
              >
                <b-form-input
                  id="domicilio"
                  v-model="clienteData.domicilio"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

        </b-row>
        <!-- Action Buttons -->
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          type="submit"
        >
          {{ $t('Lists.saveChanges') }}
        </b-button>
        <b-button
          variant="outline-secondary"
          type="reset"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
        >
          {{ $t('Lists.reset') }}
        </b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BButton, BRow, BCol, BFormGroup, BFormInput, BForm, BFormInvalidFeedback,
} from 'bootstrap-vue'
import router from '@/router'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import {
  required, alphaNum, email, min, max,
} from '@validations'
import customerService from '@/services/customer.service'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormInvalidFeedback,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    customerData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      min,
      max,
    }
  },
  setup(props) {
    /* Services */
    const {
      updateCustomer,
    } = customerService()
    const clienteData = ref(JSON.parse(JSON.stringify(props.customerData)))

    const resetclienteData = () => {
      clienteData.value = JSON.parse(JSON.stringify(props.customerData))
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetclienteData)

    const onSubmit = () => {
      updateCustomer(clienteData.value)
        .then(() => {
          router.push({ name: 'apps-customers-list' })
        })
    }

    return {
      // Services
      updateCustomer,
      onSubmit,

      // Validation
      refFormObserver,
      getValidationState,
      resetForm,

      clienteData,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
